import { createStore } from 'vuex';

export default createStore({
    state: {
        textSnippets: [] as any,
    },
    mutations: {
        ADD_SNIPPET(state, snippet) {
            state.textSnippets.push(snippet);
        },
        REMOVE_SNIPPET(state, index) {
            state.textSnippets.splice(index, 1);
        },
    },
    actions: {
        addSnippet({ commit }, snippet) {
            commit('ADD_SNIPPET', snippet);
        },
        removeSnippet({ commit }, index) {
            commit('REMOVE_SNIPPET', index);
        },
    },
});
